import { Box, useTheme } from "@mui/material";
import * as React from "react";

import { EventNameForm } from "@/shared/components/events/EventNameForm";
import { EventRecord } from "@/shared/domain/events";
import { useUpdateEvent } from "@/shared/domain/events/hooks";

import styles from "./EditableEventName.module.css";

interface EditableEventNameProps {
  event: EventRecord;
  readonly: boolean;
}

export function EditableEventName({ event, readonly }: EditableEventNameProps) {
  const theme = useTheme();

  const updateEvent = useUpdateEvent();

  const [isEditing, setIsEditing] = React.useState<boolean>(false);

  if (isEditing) {
    return (
      <EventNameForm
        name={event.name}
        onSubmit={async (name) => {
          await updateEvent.mutateAsync({
            id: event.event_id,
            requestBody: {
              name,
            },
          });
          setIsEditing(false);
        }}
        onCancel={() => setIsEditing(false)}
        inputClassName={styles.name}
      />
    );
  }

  return (
    <Box
      onClick={() => !readonly && setIsEditing(true)}
      sx={
        readonly
          ? {}
          : {
              ":hover": {
                backgroundColor: theme.palette.hoverBackground.main,
                borderRadius: "0.25rem",
                cursor: "pointer",
              },
            }
      }
    >
      {event.name}
    </Box>
  );
}
